<template>
    <div>
        <b-modal id="auth-modal" v-model="modalLogin" title="Autenticação" size="sm">
            <p class="text-secondary mb-3">
                Insira um número de celular válido para receber o código de segurança para acessar sua conta:
            </p>
            <b-form-group label-for="inputLogin">
                <b-input-group>
                    <b-input-group-prepend is-text>
                        <i class="fa fa-mobile fa-lg"></i>
                    </b-input-group-prepend>
                    <b-form-input id="inputLogin" v-model="data.inputLogin" name="inputLogin"
                        v-validate="'required|telefone'" :state="!errors.has('inputLogin')" placeholder="(00)00000-0000"
                        v-mascara-telefone></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback v-if="errors.has('inputLogin')">
                    {{ errors.first('inputLogin') }}
                </b-form-invalid-feedback>
            </b-form-group>
            <template #modal-footer>
                <div class="w-100 d-flex justify-content-end">
                    <b-button class="c-btn-color-agenda-pro" @click="$emit('solicitaCodigo')">
                        <i class="fa fa-sign-in mr-1"></i>
                        Continuar
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import '@/shared/plugins/recaptcha'
import { Validator } from 'vee-validate';


Validator.extend('telefone', {
    getMessage: () => 'Insira um telefone no formato (00)00000-0000.',
    validate: value => /^\(\d{1,2}\)\d{5}-\d{4}$/.test(value)
})

export default {
    name: 'Login',
    props: {
        data: {
            type: Object
        },
    },
    computed: {
        modalLogin: {
            get() {
                return this.$store.getters['usuarios/pegaModalLogin']
            },
            set(valor) {
                this.$store.commit('usuarios/atualizaModalLogin', valor)
            }
        }
    },
    data() {
        return {}
    },
    $_veeValidate: {
        validator: 'new'
    },
    methods: {
    }
}
</script>
